export default "__VITE_ASSET__DDMyA1SH__"